var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterBird = function SvgTwitterBird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.75 5.131a9.5 9.5 0 0 1-2.651.718 4.57 4.57 0 0 0 2.03-2.513c-.907.531-1.899.903-2.932 1.102a4.65 4.65 0 0 0-3.37-1.44c-2.552 0-4.616 2.035-4.616 4.543a4.4 4.4 0 0 0 .12 1.036 13.16 13.16 0 0 1-9.516-4.749 4.5 4.5 0 0 0-.628 2.283c0 1.575.822 2.967 2.062 3.783a4.6 4.6 0 0 1-2.099-.567v.056c0 2.203 1.594 4.036 3.703 4.453-.396.106-.805.16-1.215.16q-.439 0-.868-.085c.586 1.805 2.293 3.117 4.315 3.155a9.36 9.36 0 0 1-6.836 1.88 13.06 13.06 0 0 0 7.066 2.053c8.502 0 13.146-6.924 13.146-12.929q0-.295-.015-.586a9.3 9.3 0 0 0 2.303-2.353"
  })));
};
export default SvgTwitterBird;